import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BaseMapTileLayerManager } from "../manager/mapLayerManager";
import { Base } from "./base";
export var MapTileLayer = /*#__PURE__*/function (_Base) {
  _inherits(MapTileLayer, _Base);

  var _super = _createSuper(MapTileLayer);

  function MapTileLayer(_ref) {
    var _parentSource$data;

    var _this;

    var parent = _ref.parent,
        rendererService = _ref.rendererService,
        mapService = _ref.mapService,
        layerService = _ref.layerService;

    _classCallCheck(this, MapTileLayer);

    _this = _super.call(this);
    var parentSource = parent.getSource();

    var _ref2 = (parentSource === null || parentSource === void 0 ? void 0 : (_parentSource$data = parentSource.data) === null || _parentSource$data === void 0 ? void 0 : _parentSource$data.tilesetOptions) || {},
        sourceLayer = _ref2.sourceLayer;

    _this.sourceLayer = sourceLayer;
    _this.parent = parent;
    _this.mapService = mapService;
    _this.layerService = layerService;
    _this.tileLayerManager = new BaseMapTileLayerManager(parent, mapService, rendererService);

    _this.initTileSetManager();

    return _this;
  }

  return _createClass(MapTileLayer);
}(Base);